import React from 'react';
import { compose } from 'recompose';
import { Blockquote } from '@queensland-running/qr-components';

const enhance = compose(React.memo);

const AllSchoolsChampionshipView = () => (
  <>
    <Blockquote color="neutral">
      <p>Medals for Schools Prep Races will be presented as soon as possible after the conclusion of each race. Only student runners entered specifically in the Schools Prep Meet will be eligible for Medals. Student runners competing in their age group will take part in the first of the two start options for the distance. Any other runners will take part in the 'open' start time.</p>
        <p>The courses set for the Schools Prep Meet will mirror, as closely as is possible, courses used for all 2026 Queensland School Sport District and Regional Competitions.</p>
    </Blockquote>

  </>
);

export const AllSchoolsChampionships = enhance(AllSchoolsChampionshipView);
